import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { map, Observable, tap } from 'rxjs';
import { AuthService } from 'svnxii-modules/auth/services';

@Injectable({ providedIn: 'root' })
export class OnboardingCompleteGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.auth.checkReadiness().pipe(
      map((res) => {
        if (!res.isComplete) {
          return this.router.createUrlTree(['/onboarding']);
        }
        localStorage.setItem('rowVersion', res.rowVersion ?? '');

        return true;
      }),
    );
  }
}
